export const getFirstNames = (fullName) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(" ");
  while (parts.length > 1 && /^[A-Z]\.?$/.test(parts[parts.length - 2])) {
    parts.splice(parts.length - 2, 1);
  }
  if (parts.length > 1) parts.pop();
  return parts.join(" ");
};

export const formatTime = (currentTime) =>
  currentTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

export const formatDate = (currentTime) =>
  currentTime.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    weekday: "short",
  });
